/* eslint-disable */
/*
/* This file is generated automatically by i18n preprocessor. Do not modify it directly.
 */
import { addLang, locale } from '../src/locale';

const defaultLocale = 'en-US';
const i18n = {
  "en-US": {
    "alert": {
      "close": "Close"
    }
  },
  "de-DE": {
    "alert": {
      "close": "Schließen"
    }
  },
  "es-ES": {
    "alert": {
      "close": "Cerrar"
    }
  },
  "fr-FR": {
    "alert": {
      "close": "Fermer"
    }
  },
  "id-ID": {
    "alert": {
      "close": "Tutup"
    }
  },
  "it-IT": {
    "alert": {
      "close": "Chiudi"
    }
  },
  "jp-JP": {
    "alert": {
      "close": "閉じる"
    }
  },
  "ko-KO": {
    "alert": {
      "close": "닫기"
    }
  },
  "nl-NL": {
    "alert": {
      "close": "Sluiten"
    }
  },
  "pl-PL": {
    "alert": {
      "close": "Zamknij"
    }
  },
  "pt-PT": {
    "alert": {
      "close": "Fechar"
    }
  },
  "ru-RU": {
    "alert": {
      "close": "Закрыть"
    }
  },
  "tr-TR": {
    "alert": {
      "close": "Kapat"
    }
  },
  "vi-VN": {
    "alert": {
      "close": "Đóng"
    }
  },
  "zh-CN": {
    "alert": {
      "close": "关闭"
    }
  },
  "zh-TW": {
    "alert": {
      "close": "關閉"
    }
  }
};
const lang = i18n[locale] ? i18n[locale] : i18n[defaultLocale];

addLang(lang);
